// Smart Sash Admin Panel - Dirty State Warning Hook
// Shows browser warning when navigating away with unsaved changes

import { useEffect } from 'react';

/**
 * Hook that shows a browser warning dialog when the user tries to
 * navigate away or close the tab while there are unsaved changes.
 *
 * @param isDirty - Whether there are unsaved changes
 */
export function useDirtyStateWarning(isDirty: boolean): void {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);
}
